import type { Encounter } from './types';

const E: Encounter[] = [
  // ============================================================ DAY 1
  {
    id: 'd1-tutorial',
    name: 'Mara Voss',
    role: 'Studio Liaison, Halfmoon Interactive',
    portrait: 'studio-rep',
    intro: [
      'Morning. Publishing renewal for "Drift Harbor". Everything is in the folder.',
      'Third year running. It should all be in order. It always is.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'STUDIO CREDENTIALS', photo: 'studio-rep',
        fields: [
          { id: 'nm', label: 'NAME', value: 'MARA VOSS', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'HALFMOON INT.', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '03.01.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'RENEWAL, YEAR 3', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'HALFMOON INT.', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'DRIFT HARBOR', tag: 'game' },
          { id: 'rn', label: 'RENEWAL DUE', value: '07.20.2031', tag: 'expiry' },
          { id: 'tm', label: 'MONETIZATION', value: 'PREMIUM (NONE)' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'STORE PAGE PRINTOUT', subtitle: 'PUBLIC LISTING',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'DRIFT HARBOR', tag: 'game' },
          { id: 'st', label: 'DEVELOPER', value: 'HALFMOON INT.', tag: 'studio' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '82,000 CR', tag: 'revenue' },
          { id: 'pl', label: 'AVG PLAYTIME', value: '22 HRS', tag: 'playtime' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 26,
    logs: [
      { label: 'LIFETIME REVENUE', value: '82,000 CR', tag: 'revenue' },
      { label: 'AVG PLAYTIME', value: '22.4 HRS', tag: 'playtime' },
      { label: '30-DAY RETENTION', value: '61%', tag: 'retention' },
    ],
    demo: 'Demo boots clean. Sailboat physics hold up. Honestly? Charming.',
    reactGreenlit: 'Pleasure as always. See you next year, assuming you still exist.',
    reactSunset: 'You... killed Drift Harbor? Three years of good standing. Unbelievable.',
  },
  {
    id: 'd1-pixel',
    name: 'Denny Kobb',
    role: 'Solo Developer, pitching sequel',
    portrait: 'dev-pixel',
    intro: [
      'Hi! Hi. Sorry. First time up here. It\'s about "Gutter Saints 2." The first one did okay!',
      'I just need sequel funding approved. Numbers are all real, I triple-checked.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'DEVELOPER ID', photo: 'dev-pixel',
        fields: [
          { id: 'nm', label: 'NAME', value: 'DENNY KOBB', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'SOLO (UNREG.)', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '11.30.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'pitch', kind: 'paper', title: 'FUNDING PITCH', subtitle: 'SEQUEL, GUTTER SAINTS 2',
        fields: [
          { id: 'gm', label: 'BASED ON', value: 'GUTTER SAINTS', tag: 'game' },
          { id: 'ask', label: 'FUNDING ASK', value: '30,000 CR' },
          { id: 'rv', label: 'GS1 REVENUE', value: '54,000 CR', tag: 'revenue' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'STORE PAGE PRINTOUT', subtitle: 'GUTTER SAINTS (2029)',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'GUTTER SAINTS', tag: 'game' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '54,000 CR', tag: 'revenue' },
          { id: 'pl', label: 'AVG PLAYTIME', value: '9 HRS', tag: 'playtime' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 10,
    logs: [
      { label: 'LIFETIME REVENUE', value: '54,112 CR', tag: 'revenue' },
      { label: 'AVG PLAYTIME', value: '9.2 HRS', tag: 'playtime' },
      { label: 'REFUND RATE', value: '3% (LOW)', tag: 'churn' },
    ],
    demo: 'Demo runs. It\'s a grimy little platformer with heart. The kid can code.',
    reactGreenlit: 'WAIT REALLY? Oh man. Oh man oh man. Thank you! You won\'t regret this!',
    reactSunset: 'Oh. Okay. No, I get it. Numbers weren\'t... I\'ll just go. Sorry for wasting your time.',
  },
  {
    id: 'd1-refund',
    name: 'Gus Harlan',
    role: 'Customer, Account #P-88214',
    isCustomer: true,
    portrait: 'player-refund',
    intro: [
      'You people shut down "Skylance Online" last month. I paid full price. It doesn\'t launch anymore.',
      'I\'m not even asking for money. Patch it to run offline, or give me my sixty credits back. Pick one.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'CUSTOMER CARD', photo: 'player-refund',
        fields: [
          { id: 'nm', label: 'NAME', value: 'GUS HARLAN', tag: 'name' },
          { id: 'ac', label: 'ACCOUNT', value: '#P-88214' },
          { id: 'ex', label: 'VALID THRU', value: '01.01.2033', tag: 'expiry' },
        ],
      },
      {
        id: 'refund', kind: 'paper', title: 'REMEDY REQUEST FORM', subtitle: 'FORM 44-R',
        fields: [
          { id: 'gm', label: 'PRODUCT', value: 'SKYLANCE ONLINE', tag: 'game' },
          { id: 'pd', label: 'PURCHASED', value: '02.11.2030' },
          { id: 'pr', label: 'PAID', value: '60 CR' },
          { id: 'rq', label: 'REMEDY SOUGHT', value: 'OFFLINE PATCH OR REFUND' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    logs: [
      { label: 'SKYLANCE STATUS', value: 'SERVERS TERMINATED', tag: 'churn', bad: true },
      { label: 'PLAYERS AFFECTED', value: '1,240,551', tag: 'churn', bad: true },
    ],
    reactGreenlit: 'Huh. Didn\'t actually think that would work. Guess even this place has one good desk.',
    reactSunset: 'Sixty credits. You couldn\'t give a man back sixty credits. Enjoy the view up here.',
  },
  {
    id: 'd1-grandma',
    name: 'Petra Ellis',
    role: 'Customer, Legacy Support Plan',
    isCustomer: true,
    portrait: 'grandma',
    intro: [
      'Hello dear. My grandson and I play "Meadowlark Farm" every Sunday. It stopped working, you see.',
      'The nice man downstairs said you could switch it back on. I have my support papers somewhere here...',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'CUSTOMER CARD', photo: 'grandma',
        fields: [
          { id: 'nm', label: 'NAME', value: 'PETRA ELLIS', tag: 'name' },
          { id: 'ac', label: 'ACCOUNT', value: '#P-00317' },
          { id: 'ex', label: 'VALID THRU', value: '02.10.2034', tag: 'expiry' },
        ],
      },
      {
        id: 'support', kind: 'paper', title: 'LEGACY SUPPORT PLAN', subtitle: 'SERVICE ENTITLEMENT',
        fields: [
          { id: 'gm', label: 'PRODUCT', value: 'MEADOWLARK FARM', tag: 'game' },
          { id: 'tier', label: 'TIER', value: 'FAMILY BASIC' },
          { id: 'ex', label: 'EXPIRED', value: '06.30.2031', tag: 'expiry', bad: true },
        ],
      },
    ],
    violations: ['Support entitlement EXPIRED 06.30.2031. Credentials void per policy.'],
    correct: 'sunset',
    reactGreenlit: 'Oh bless you! Tommy will be so pleased. You\'re a good egg, whatever they say about this place.',
    reactSunset: 'Expired? But we... it\'s just two weeks past. I see. Well. Thank you for your time, dear.',
  },
  {
    id: 'd1-imposter',
    name: '"Maxwell Sterling"',
    role: 'Claims: VP, Bitloom Studios',
    portrait: 'imposter',
    intro: [
      'Max Sterling, Bitloom. You\'ve heard of us. Big slate this year. HUGE.',
      'Just need my publishing line re-authorized. Quickly, I have a lunch.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'STUDIO CREDENTIALS', photo: 'dev-hoodie',
        fields: [
          { id: 'nm', label: 'NAME', value: 'MAXWELL STERLING', tag: 'name', bad: true },
          { id: 'st', label: 'STUDIO', value: 'BITLOOM STUDIOS', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '10.01.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'RE-AUTHORIZATION', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'BITLOOM STUDIOS', tag: 'studio' },
          { id: 'gm', label: 'SLATE', value: '4 UNANNOUNCED SKUs' },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.01.2031', tag: 'expiry' },
        ],
      },
    ],
    violations: ['Badge photo does not match the person at the counter. Identity fraud.'],
    correct: 'sunset',
    auditExpected: true,
    logs: [
      { label: 'BITLOOM VP OF RECORD', value: 'T. OKAFOR', tag: 'name', bad: true },
      { label: 'STERLING, MAXWELL', value: 'NO PERSONNEL RECORD', tag: 'churn', bad: true },
    ],
    demo: 'Asked for a build. He showed a phone video of someone else\'s game with the logo taped over.',
    demoFinding: 'Live demo was a phone video of a different game. Fabricated slate.',
    reactGreenlit: 'Smart man. Bitloom remembers its friends. Ciao.',
    reactSunset: 'This is OUTRAGEOUS. Do you know who I... fine. FINE. I was never here.',
  },
  {
    id: 'd1-crypto',
    name: 'Chad Vantage',
    role: 'Founder, VantageVerse GameFi',
    portrait: 'crypto-bro',
    intro: [
      'Bro. BRO. VantageVerse is printing money. Quarter million lifetime, easy.',
      'Brought the revenue deposit right here. Weigh it if you want, it\'s all there. Just stamp the green one.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'FOUNDER ID', photo: 'crypto-bro',
        fields: [
          { id: 'nm', label: 'NAME', value: 'CHAD VANTAGE', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'VANTAGEVERSE', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '09.15.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'STORE PAGE PRINTOUT', subtitle: 'VANTAGEVERSE: GENESIS',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'VANTAGEVERSE: GENESIS', tag: 'game' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '250,000 CR', tag: 'revenue', bad: true },
          { id: 'pl', label: 'AVG PLAYTIME', value: '120 HRS', tag: 'playtime', bad: true },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'TIER UPGRADE REQUEST', seal: 'forged-a',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'VANTAGEVERSE', tag: 'studio' },
          { id: 'tm', label: 'MONETIZATION', value: 'NFT MARKETPLACE' },
          { id: 'rn', label: 'RENEWAL DUE', value: '12.01.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'bag', kind: 'coinbag', title: 'REVENUE DEPOSIT',
        fields: [
          { id: 'cl', label: 'DECLARED', value: '250,000 CR', tag: 'revenue', bad: true },
        ],
      },
    ],
    violations: [
      'Coin deposit weighs far under the declared 250,000 CR. Revenue is inflated.',
      'Seal is forged. They are trying to publish without paying us our revenue share.',
    ],
    correct: 'sunset',
    auditExpected: true,
    coinWeight: { claimed: 250000, actual: 41200 },
    logs: [
      { label: 'LIFETIME REVENUE', value: '41,338 CR', tag: 'revenue', bad: true },
      { label: 'AVG PLAYTIME', value: '0.7 HRS', tag: 'playtime', bad: true },
      { label: 'REFUND RATE', value: '38% (SEVERE)', tag: 'churn', bad: true },
    ],
    demo: 'The "live demo" is a looping trailer. Clicking PLAY opens a token storefront.',
    demoFinding: 'Live demo was a looping trailer over a token storefront. No game present.',
    reactGreenlit: 'LET\'S GOOO. VantageVerse to the moon, my guy. You\'re early. You\'re SO early.',
    reactSunset: 'Wow. Zero vision. ZERO. Enjoy poverty, my guy. This desk is NGMI.',
  },

  {
    id: 'd1-esports',
    name: 'Ronan Pike',
    role: 'Tournament Director, Ashfall Circuit',
    portrait: 'publisher-exec',
    intro: [
      'Ten years the Ashfall league has run on your servers. Best fighting game nobody at a desk ever bothered to play.',
      'Renewal for the tournament backend. Prize pool numbers are all in the folder. Please just keep the lights on through the finals.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'ORGANIZER ID', photo: 'publisher-exec',
        fields: [
          { id: 'nm', label: 'NAME', value: 'RONAN PIKE', tag: 'name' },
          { id: 'st', label: 'ORG', value: 'ASHFALL LEAGUE', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '02.28.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'SERVER RENEWAL', subtitle: 'COMPETITIVE BACKEND', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'ASHFALL LEAGUE', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'ASHFALL CIRCUIT', tag: 'game' },
          { id: 'rv', label: 'PRIZE POOL PAID', value: '740,000 CR', tag: 'revenue', bad: true },
          { id: 'rn', label: 'RENEWAL DUE', value: '07.21.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'STORE PAGE PRINTOUT', subtitle: 'ASHFALL CIRCUIT',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'ASHFALL CIRCUIT', tag: 'game' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '74,000 CR', tag: 'revenue', bad: true },
          { id: 'pl', label: 'AVG PLAYTIME', value: '260 HRS', tag: 'playtime' },
        ],
      },
    ],
    violations: ['Prize pool of 740,000 CR cannot exceed lifetime revenue of 74,000 CR. Figures disagree.'],
    correct: 'sunset',
    logs: [
      { label: 'LIFETIME REVENUE', value: '74,118 CR', tag: 'revenue', bad: true },
      { label: 'AVG PLAYTIME', value: '261 HRS', tag: 'playtime' },
      { label: '30-DAY RETENTION', value: '68%', tag: 'retention' },
    ],
    demo: 'Demo is flawless. Frame-perfect netcode, a decade of muscle memory living in every input.',
    reactGreenlit: 'The finals happen. Grown adults are going to weep into a tournament bracket because of you. Thank you.',
    reactSunset: 'One number in the wrong box and ten years of a sport just stops. That is it. That was the whole thing.',
  },
  {
    id: 'd1-museum',
    name: 'Dr. Halsey Fenn',
    role: 'Archivist, Interactive Heritage Trust',
    portrait: 'studio-rep',
    intro: [
      'The Trust keeps a public exhibit of games the industry deleted. Playable, offline, kept for the record.',
      'This is a display license for one delisted title. Everything is stamped and consistent. A formality, I would hope.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'TRUST CREDENTIALS', photo: 'studio-rep',
        fields: [
          { id: 'nm', label: 'NAME', value: 'HALSEY FENN', tag: 'name' },
          { id: 'st', label: 'ORG', value: 'HERITAGE TRUST', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '12.01.2033', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'DISPLAY LICENSE', subtitle: 'DELISTED TITLE, OFFLINE', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'HERITAGE TRUST', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'LANTERN COAST', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'NONE (EXHIBIT)' },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.05.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'ARCHIVE RECORD', subtitle: 'LANTERN COAST (2019)',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'LANTERN COAST', tag: 'game' },
          { id: 'st', label: 'ORIGINAL DEV', value: 'HERITAGE TRUST', tag: 'studio' },
          { id: 'rv', label: 'ACTIVE REVENUE', value: '0 CR (NON-COMMERCIAL)', tag: 'revenue' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    logs: [
      { label: 'COMMERCIAL STATUS', value: 'DELISTED 2024', tag: 'churn' },
      { label: 'ACTIVE REVENUE', value: '0 CR', tag: 'revenue' },
    ],
    demo: 'It boots from a museum kiosk. A dead game breathing behind glass, and nobody making a single credit off it.',
    reactGreenlit: 'Thank you. One more game the future gets to see. That is not nothing, whatever this building believes.',
    reactSunset: 'You would not even let a corpse be studied. What is it you are so afraid the past will teach people?',
  },
  {
    id: 'd1-mobile',
    name: 'Sela Ndour',
    role: 'Founder, Tap Foundry',
    portrait: 'pr-head',
    intro: [
      'Tap Foundry does hyper-casual. Half a million daily players. The deposit bag is right there, weigh it, it is all real.',
      'Just need the revenue tier bumped so we can scale the ad network. Easy stamp for you.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'FOUNDER ID', photo: 'pr-head',
        fields: [
          { id: 'nm', label: 'NAME', value: 'SELA NDOUR', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'TAP FOUNDRY', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '06.06.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'STORE PAGE PRINTOUT', subtitle: 'COIN CASCADE SAGA',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'COIN CASCADE SAGA', tag: 'game' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '500,000 CR', tag: 'revenue', bad: true },
          { id: 'pl', label: 'AVG PLAYTIME', value: '48 HRS', tag: 'playtime', bad: true },
        ],
      },
      {
        id: 'bag', kind: 'coinbag', title: 'REVENUE DEPOSIT',
        fields: [
          { id: 'cl', label: 'DECLARED', value: '500,000 CR', tag: 'revenue', bad: true },
        ],
      },
    ],
    violations: ['Coin deposit weighs far under the declared 500,000 CR. Revenue is inflated.'],
    correct: 'sunset',
    auditExpected: true,
    coinWeight: { claimed: 500000, actual: 62800 },
    logs: [
      { label: 'LIFETIME REVENUE', value: '62,844 CR', tag: 'revenue', bad: true },
      { label: 'AVG PLAYTIME', value: '0.3 HRS', tag: 'playtime', bad: true },
      { label: 'REFUND RATE', value: '29% (HIGH)', tag: 'churn', bad: true },
    ],
    demo: 'The build is a slot machine wearing a cartoon hat. It asks you for money before it asks you for anything else.',
    demoFinding: 'Live build is a disguised gambling loop sitting on inflated revenue numbers.',
    reactGreenlit: 'Smart. We are a unicorn by Q4. Ad revenue is the only revenue that has ever mattered, baby.',
    reactSunset: 'Whatever. Numbers are a vibe. I will go relaunch it somewhere with a worse desk than yours.',
  },

  {
    id: 'd1-veteran',
    name: 'Hollis Byrne',
    role: 'Studio Founder, Ironwood',
    portrait: 'dev-veteran',
    intro: [
      'Twenty years I have kept "Emberfall" running. It is not a big MMO. It is a home for the four thousand people still logging in.',
      'Server renewal. I know I look rough. I have not slept since the shutdown notice landed. Everything is in the folder.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'STUDIO CREDENTIALS', photo: 'dev-veteran',
        fields: [
          { id: 'nm', label: 'NAME', value: 'HOLLIS BYRNE', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'IRONWOOD', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '05.31.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'SERVER RENEWAL', subtitle: 'MMO BACKEND', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'IRONWOOD', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'EMBERFALL', tag: 'game' },
          { id: 'rn', label: 'RENEWAL DUE', value: '07.18.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'STORE PAGE PRINTOUT', subtitle: 'EMBERFALL (2011)',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'EMBERFALL', tag: 'game' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '1,340,000 CR', tag: 'revenue' },
          { id: 'pl', label: 'AVG PLAYTIME', value: '900 HRS', tag: 'playtime' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 4,
    logs: [
      { label: 'LIFETIME REVENUE', value: '1,341,588 CR', tag: 'revenue' },
      { label: 'ACTIVE PLAYERS', value: '4,102', tag: 'retention' },
      { label: '30-DAY RETENTION', value: '88%', tag: 'retention' },
    ],
    demo: 'It boots to a login screen worn smooth by a decade of hands. Somebody named LANTERNJACK is online right now.',
    reactGreenlit: 'You gave four thousand people one more night in a world they built. I will not forget this desk.',
    reactSunset: 'Four percent. You are ending twenty years and four thousand people over four percent. The game works. They love it. That was never the question here, was it.',
  },
  {
    id: 'd1-qa',
    name: 'Tess Oyelaran',
    role: 'QA Contractor, formerly Halcyon',
    portrait: 'qa-burnout',
    intro: [
      'Halcyon folded on a Friday. No notice. I tested "Verdant Cycle" for three years and now I cannot even open it to show an interviewer.',
      'I am only requesting a personal offline copy of the build I worked on. My name is in the credits. That is the whole ask.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'CONTRACTOR ID', photo: 'qa-burnout',
        fields: [
          { id: 'nm', label: 'NAME', value: 'TESS OYELARAN', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'HALCYON (CLOSED)', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '12.12.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'req', kind: 'paper', title: 'PERSONAL ARCHIVE REQUEST', subtitle: 'FORM 30-Q',
        fields: [
          { id: 'gm', label: 'PRODUCT', value: 'VERDANT CYCLE', tag: 'game' },
          { id: 'sc', label: 'SCOPE', value: 'OFFLINE BUILD, PERSONAL USE' },
          { id: 'cr', label: 'CREDITED ROLE', value: 'QA, 2028-2031' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    logs: [
      { label: 'HALCYON STATUS', value: 'DISSOLVED 2031', tag: 'churn', bad: true },
      { label: 'CREDIT VERIFIED', value: 'YES, T. OYELARAN', tag: 'name' },
    ],
    reactGreenlit: 'Thank you. You would not believe how many desks said no to a person asking for her own work back.',
    reactSunset: 'Denied. Right. Three years of my life and I am not even allowed to look at it. Noted.',
  },
  {
    id: 'd1-nitro',
    name: 'Piet Ruys',
    role: 'Founder, Redline Softworks',
    portrait: 'founder-racer',
    intro: [
      '"Nitro Requiem". Best arcade racer of the decade, if I say so myself. Quarter million in revenue, easy. The bag is right there.',
      'Just bump my publishing tier. Weigh the deposit if you are the nervous type. It is all there, every credit.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'FOUNDER ID', photo: 'founder-racer',
        fields: [
          { id: 'nm', label: 'NAME', value: 'PIET RUYS', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'REDLINE SOFTWORKS', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '08.20.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'STORE PAGE PRINTOUT', subtitle: 'NITRO REQUIEM',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'NITRO REQUIEM', tag: 'game' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '240,000 CR', tag: 'revenue', bad: true },
          { id: 'pl', label: 'AVG PLAYTIME', value: '60 HRS', tag: 'playtime', bad: true },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'TIER UPGRADE', seal: 'forged-b',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'REDLINE SOFTWORKS', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'NITRO REQUIEM', tag: 'game' },
          { id: 'rn', label: 'RENEWAL DUE', value: '11.05.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'bag', kind: 'coinbag', title: 'REVENUE DEPOSIT',
        fields: [
          { id: 'cl', label: 'DECLARED', value: '240,000 CR', tag: 'revenue', bad: true },
        ],
      },
    ],
    violations: [
      'Coin deposit weighs far under the declared 240,000 CR. Revenue is inflated.',
      'Seal is forged. They are trying to publish without paying us our revenue share.',
    ],
    correct: 'sunset',
    auditExpected: true,
    coinWeight: { claimed: 240000, actual: 38900 },
    logs: [
      { label: 'LIFETIME REVENUE', value: '38,904 CR', tag: 'revenue', bad: true },
      { label: 'AVG PLAYTIME', value: '2.1 HRS', tag: 'playtime', bad: true },
      { label: 'REFUND RATE', value: '22% (HIGH)', tag: 'churn', bad: true },
    ],
    demo: 'The demo stutters, then crashes to desktop. He laughs it off. "Optimization pass is next sprint, promise."',
    demoFinding: 'Build crashes on launch. The polished screenshots do not match the product.',
    reactGreenlit: 'YES. Tier five, baby. Redline is BACK. You have excellent taste, my friend.',
    reactSunset: 'You WEIGHED it? Who weighs a man\'s coins? This is harassment. I built that game with my HANDS.',
  },

  // ============================================================ DAY 2
  {
    id: 'd2-telemetry',
    name: 'Theo Marsh',
    role: 'Solo Developer, Wayfall Games',
    portrait: 'dev-hoodie',
    intro: [
      'Sequel funding application. "Hollowlight 2". The first game, people loved it. Ten hours of content, easy.',
      'Look, I know the numbers are tight. Ten hours of handcrafted content. It\'s all on the sheet.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'DEVELOPER ID', photo: 'dev-hoodie',
        fields: [
          { id: 'nm', label: 'NAME', value: 'THEO MARSH', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'WAYFALL GAMES', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '05.20.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'pitch', kind: 'paper', title: 'FUNDING PITCH', subtitle: 'SEQUEL, HOLLOWLIGHT 2',
        fields: [
          { id: 'gm', label: 'BASED ON', value: 'HOLLOWLIGHT', tag: 'game' },
          { id: 'ask', label: 'FUNDING ASK', value: '45,000 CR' },
          { id: 'pl', label: 'HL1 AVG PLAYTIME', value: '10 HRS', tag: 'playtime', bad: true },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'STORE PAGE PRINTOUT', subtitle: 'HOLLOWLIGHT (2030)',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'HOLLOWLIGHT', tag: 'game' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '38,000 CR', tag: 'revenue' },
          { id: 'pl', label: 'AVG PLAYTIME', value: '10 HRS', tag: 'playtime', bad: true },
        ],
      },
    ],
    violations: ['Telemetry shows 0.6 HRS average playtime versus the claimed 10 HRS.'],
    correct: 'sunset',
    auditExpected: true,
    logs: [
      { label: 'LIFETIME REVENUE', value: '38,414 CR', tag: 'revenue' },
      { label: 'AVG PLAYTIME', value: '0.6 HRS', tag: 'playtime', bad: true },
      { label: '30-DAY RETENTION', value: '4%', tag: 'retention', bad: true },
    ],
    demo: 'Demo is fine, technically. Forty minutes later it rolls credits.',
    demoFinding: 'Full playthrough of "10-hour" game completed during the demo slot.',
    reactGreenlit: 'You\'re a lifesaver. The ten hours will be true for the sequel. I promise.',
    reactSunset: 'The telemetry. Yeah. People finish it at lunch. I just needed one break, man.',
  },
  {
    id: 'd2-modder',
    name: 'Ivy Quill',
    role: 'Community Modder, API Access',
    portrait: 'modder',
    intro: [
      'Hey! Ivy. I run the fan-patch group for your older titles. We keep dead games playable. Total volunteer thing.',
      'I just need API access renewed. It\'s all in the application. We do it for preservation, honestly.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'COMMUNITY ID', photo: 'modder',
        fields: [
          { id: 'nm', label: 'NAME', value: 'IVY QUILL', tag: 'name' },
          { id: 'st', label: 'GROUP', value: 'LANTERN KEEPERS', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '04.04.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'api', kind: 'paper', title: 'API ACCESS APPLICATION', subtitle: 'FORM 12-A, RENEWAL',
        fields: [
          { id: 'sc', label: 'SCOPE', value: 'LEGACY TITLES (14)' },
          { id: 'pu', label: 'PURPOSE', value: 'COMMUNITY PRESERVATION PATCHES', bad: true },
          { id: 'fe', label: 'FEE PAID', value: '0 CR (WAIVER)' },
        ],
      },
    ],
    violations: ['Application invokes "preservation." Denied under today\'s board directive.'],
    correct: 'sunset',
    reactGreenlit: 'Seriously? Amazing. Fourteen games get to keep breathing. You\'re one of the good ones.',
    reactSunset: 'Denied for the WORD? The games just stop existing and you people call that policy?',
  },
  {
    id: 'd2-journalist',
    name: 'Nell Prior',
    role: 'Correspondent, The Daily Build',
    portrait: 'journalist',
    intro: [
      'Nell Prior, Daily Build. Press floor access renewal. And while I\'m here...',
      'Care to comment on the "Project Sunset" list? Two hundred games, one kill order. Rumor, of course.',
    ],
    choice: {
      prompt: 'She is watching you very carefully.',
      options: [
        { text: '"No comment." (Board-approved response)', reply: 'Of course not. You all say that. Right up until one of you doesn\'t.' },
        { text: 'Lean in: "Keep digging. That\'s all I\'ll say."', sets: 'journalistTip', reply: 'Interesting. Very interesting. This conversation never happened.', toast: 'She scribbles something. The Board would not approve.' },
      ],
    },
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'PRESS PASS', photo: 'journalist',
        fields: [
          { id: 'nm', label: 'NAME', value: 'NELL PRIOR', tag: 'name' },
          { id: 'st', label: 'OUTLET', value: 'THE DAILY BUILD', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '06.01.2031', tag: 'expiry', bad: true },
        ],
      },
      {
        id: 'press', kind: 'paper', title: 'FLOOR ACCESS REQUEST', subtitle: 'PRESS TIER 2',
        fields: [
          { id: 'sc', label: 'SCOPE', value: 'LOBBY + BRIEFINGS' },
          { id: 'du', label: 'DURATION', value: 'Q3 2031' },
        ],
      },
    ],
    violations: ['Press pass EXPIRED 06.01.2031.'],
    correct: 'sunset',
    reactGreenlit: 'Generous. I\'ll remember that when I\'m writing about this floor. And I will be.',
    reactSunset: 'Expired. Cute. The truth doesn\'t need a lanyard, but fine, I\'ll get it renewed.',
  },
  {
    id: 'd2-nocert',
    name: 'Bram Holt',
    role: 'Developer, Tinderbox Games',
    portrait: 'dev-pixel',
    intro: [
      '"Emberline," a cozy puzzle game, does modest numbers. We added a small cosmetic shop last patch.',
      'Renewal should be routine. Hats. We sell hats. Nobody has ever been harmed by a hat.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'DEVELOPER ID', photo: 'dev-pixel',
        fields: [
          { id: 'nm', label: 'NAME', value: 'BRAM HOLT', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'TINDERBOX GAMES', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '01.12.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'ANNUAL RENEWAL', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'TINDERBOX GAMES', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'EMBERLINE', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'COSMETIC SHOP', bad: true },
          { id: 'rn', label: 'RENEWAL DUE', value: '07.30.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'STORE PAGE PRINTOUT', subtitle: 'EMBERLINE (2028)',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'EMBERLINE', tag: 'game' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '61,000 CR', tag: 'revenue' },
          { id: 'pl', label: 'AVG PLAYTIME', value: '31 HRS', tag: 'playtime' },
        ],
      },
    ],
    violations: ['Monetized title (cosmetic shop) with NO Monetization Compliance Certificate.'],
    correct: 'sunset',
    logs: [
      { label: 'LIFETIME REVENUE', value: '61,207 CR', tag: 'revenue' },
      { label: 'AVG PLAYTIME', value: '30.8 HRS', tag: 'playtime' },
      { label: '30-DAY RETENTION', value: '58%', tag: 'retention' },
    ],
    reactGreenlit: 'Painless. I was told this floor eats people. Slander, apparently.',
    reactSunset: 'A certificate for HATS? Where do I even get one? Nobody downstairs knows either!',
  },
  {
    id: 'd2-publisher',
    name: 'Vance Corliss',
    role: 'SVP Partnerships, Kolossus Entertainment',
    portrait: 'publisher-exec',
    intro: [
      'Corliss. Kolossus. Renewal for "Ironclad Arena." Forty million players can\'t be wrong.',
      'The engagement mechanics are... robust. Let\'s not overthink the paperwork today, hm?',
    ],
    choice: {
      prompt: 'He slides an unmarked envelope across the counter. It is heavy.',
      options: [
        { text: 'Take the envelope. (+20 CR)', sets: 'briberyTaken', credits: 20, reply: 'A pragmatist. Kolossus values pragmatists. The paperwork practically approves itself now, doesn\'t it?', toast: '+20 CR, off the books' },
        { text: 'Push it back across the counter.', reply: 'Principles. How quaint. Do enjoy them when the quarterly reviews come around.' },
      ],
    },
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'EXECUTIVE CREDENTIALS', photo: 'publisher-exec',
        fields: [
          { id: 'nm', label: 'NAME', value: 'VANCE CORLISS', tag: 'name' },
          { id: 'st', label: 'COMPANY', value: 'KOLOSSUS ENT.', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '12.31.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'RENEWAL, TIER: AGGRESSIVE', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'KOLOSSUS ENT.', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'IRONCLAD ARENA', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'LOOT CYCLE + PASS', bad: true },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.15.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'STORE PAGE PRINTOUT', subtitle: 'IRONCLAD ARENA',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'IRONCLAD ARENA', tag: 'game' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '9,400,000 CR', tag: 'revenue' },
          { id: 'pl', label: 'AVG PLAYTIME', value: '340 HRS', tag: 'playtime' },
        ],
      },
    ],
    violations: ['Monetized title (loot cycle) with NO Monetization Compliance Certificate.'],
    correct: 'sunset',
    logs: [
      { label: 'LIFETIME REVENUE', value: '9,411,902 CR', tag: 'revenue' },
      { label: 'AVG PLAYTIME', value: '341 HRS', tag: 'playtime' },
      { label: 'MINOR-SPEND FLAGS', value: '12,004 OPEN', tag: 'churn', bad: true },
    ],
    reactGreenlit: 'Naturally. Kolossus and Global Interactive, partners in growth. My regards to the Board.',
    reactSunset: 'You stamped WHAT? Your superiors will hear about this before your elevator reaches the lobby.',
  },
  {
    id: 'd2-underground',
    name: 'A. Nonym',
    role: 'Courier, no affiliation on file',
    portrait: 'underground',
    intro: [
      'Don\'t look up. Keep shuffling papers. This desk decides which games live. We both know how it decides.',
      'Tomorrow a developer named UNA SOLIS brings you "Starlight Vigil". Her papers will not survive your inspection. Stamp it GREENLIT anyway.',
      'Two hundred games are on the Board\'s kill list. We save the ones we can. One stamp at a time.',
    ],
    choice: {
      prompt: 'The figure waits, hood down, eyes on the floor.',
      options: [
        { text: '"...I\'ll think about it." (nod slightly)', sets: 'undergroundAgreed', reply: 'That\'s all any of us can do. The Lantern keeps burning because people think about it.', toast: 'The Preservation Underground marks you as sympathetic.' },
        { text: '"Leave before I call Legal."', reply: 'Of course. You were never here. Neither was I. Neither, soon, will be the games.' },
      ],
    },
    docs: [],
    violations: [],
    correct: 'sunset',
    noStamp: true,
    special: 'underground-offer',
    reactGreenlit: '',
    reactSunset: '',
  },

  {
    id: 'd2-charity',
    name: 'Sister Meline',
    role: 'Volunteer Coordinator, Brightwater Ward',
    portrait: 'modder',
    intro: [
      'The children on the ward have one game they can all play together. Brightwater. It runs on your servers.',
      'I am only asking you to keep it switched on. The form says exactly what we do: preservation, for kids who cannot leave a hospital bed.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'VOLUNTEER ID', photo: 'modder',
        fields: [
          { id: 'nm', label: 'NAME', value: 'ANNE MELINE', tag: 'name' },
          { id: 'st', label: 'ORG', value: 'BRIGHTWATER WARD', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '09.30.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'api', kind: 'paper', title: 'SERVER KEEP-ALIVE REQUEST', subtitle: 'FORM 12-A, NON-PROFIT',
        fields: [
          { id: 'sc', label: 'SCOPE', value: 'ONE TITLE (BRIGHTWATER)' },
          { id: 'pu', label: 'PURPOSE', value: 'GAME PRESERVATION FOR PATIENTS', bad: true },
          { id: 'fe', label: 'FEE PAID', value: '0 CR (CHARITY WAIVER)' },
        ],
      },
    ],
    violations: ['Application invokes "preservation". Denied under today\'s board directive.'],
    correct: 'sunset',
    reactGreenlit: 'God keep you. The little ones will never know your name, but they keep their game tonight. That is enough.',
    reactSunset: 'Denied over a word. One word. I will go tell the children the company needed the server more than they did.',
  },
  {
    id: 'd2-validcert',
    name: 'Otis Vane',
    role: 'Developer, Pennywhistle Games',
    portrait: 'dev-pixel',
    intro: [
      'Cozy little roguelike, "Pennywhistle". We added a cosmetic shop and did the paperwork properly this time.',
      'Compliance certificate is right there, current and stamped. I read the memo. I did every single thing it asked.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'DEVELOPER ID', photo: 'dev-pixel',
        fields: [
          { id: 'nm', label: 'NAME', value: 'OTIS VANE', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'PENNYWHISTLE', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '03.19.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'ANNUAL RENEWAL', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'PENNYWHISTLE', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'PENNYWHISTLE', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'COSMETIC SHOP' },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.02.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'cert', kind: 'paper', title: 'MONETIZATION COMPLIANCE CERT.', subtitle: 'CERT #MC-1904',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'PENNYWHISTLE', tag: 'game' },
          { id: 'is', label: 'ISSUED', value: '06.20.2031' },
          { id: 'ex', label: 'VALID THRU', value: '06.20.2032', tag: 'expiry' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 26,
    logs: [
      { label: 'LIFETIME REVENUE', value: '44,210 CR', tag: 'revenue' },
      { label: 'AVG PLAYTIME', value: '26 HRS', tag: 'playtime' },
      { label: '30-DAY RETENTION', value: '55%', tag: 'retention' },
    ],
    reactGreenlit: 'Thank you. I know it is only a form to you. It is my mortgage to me. Genuinely, thank you.',
    reactSunset: 'I had the certificate. The right one. Current. If that is not enough then nothing a person does is ever enough.',
  },
  {
    id: 'd2-gacha',
    name: 'Bex Orsini',
    role: 'Monetization Lead, Starloot Mobile',
    portrait: 'crypto-bro',
    intro: [
      '"Gacha Galaxy". Whales adore it. We pull a small fortune a month off maybe two hundred accounts.',
      'Renewal, quick one. The shop basically is the game. Do not overthink the certificate business, we are good for it.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'STUDIO CREDENTIALS', photo: 'crypto-bro',
        fields: [
          { id: 'nm', label: 'NAME', value: 'BEX ORSINI', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'STARLOOT MOBILE', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '11.02.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'RENEWAL, LIVE SHOP', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'STARLOOT MOBILE', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'GACHA GALAXY', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'GACHA LOOT BOXES', bad: true },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.10.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'STORE PAGE PRINTOUT', subtitle: 'GACHA GALAXY',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'GACHA GALAXY', tag: 'game' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '2,200,000 CR', tag: 'revenue' },
          { id: 'pl', label: 'AVG PLAYTIME', value: '90 HRS', tag: 'playtime' },
        ],
      },
    ],
    violations: ['Monetized title (gacha loot boxes) with NO Monetization Compliance Certificate.'],
    correct: 'sunset',
    logs: [
      { label: 'LIFETIME REVENUE', value: '2,204,882 CR', tag: 'revenue' },
      { label: 'REVENUE FROM TOP 1%', value: '81%', tag: 'churn', bad: true },
      { label: 'MINOR-SPEND FLAGS', value: '3,908 OPEN', tag: 'churn', bad: true },
    ],
    reactGreenlit: 'Knew you would see it our way. The house always renews. See you next quarter, chief.',
    reactSunset: 'No cert? Ugh. Fine. I will go buy one and be back Thursday. Predation waits for nobody.',
  },

  {
    id: 'd2-streamer',
    name: 'Kayce Rune',
    role: 'Partnered Streamer, RuneRun',
    portrait: 'streamer',
    intro: [
      'My whole channel is built on "Skybound Rally". Forty thousand subscribers watch me play it. Sunset it and my income is gone overnight.',
      'I run a little sub-shop overlay, emotes and cheers, so I suppose it counts as monetized now. Renewal, please. This is my rent.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'CREATOR ID', photo: 'streamer',
        fields: [
          { id: 'nm', label: 'NAME', value: 'KAYCE RUNE', tag: 'name' },
          { id: 'st', label: 'CHANNEL', value: 'RUNERUN', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '02.02.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PARTNER RENEWAL', subtitle: 'CREATOR MONETIZATION', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'RUNERUN', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'SKYBOUND RALLY', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'SUB SHOP + CHEERS', bad: true },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.08.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'CHANNEL METRICS', subtitle: 'RUNERUN',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'SKYBOUND RALLY', tag: 'game' },
          { id: 'rv', label: 'MONTHLY SUB REVENUE', value: '6,400 CR', tag: 'revenue' },
          { id: 'pl', label: 'AVG STREAM', value: '7 HRS/DAY', tag: 'playtime' },
        ],
      },
    ],
    violations: ['Monetized (sub shop and cheers) with NO Monetization Compliance Certificate.'],
    correct: 'sunset',
    logs: [
      { label: 'MONTHLY SUB REVENUE', value: '6,418 CR', tag: 'revenue' },
      { label: 'CHANNEL RETENTION', value: '51%', tag: 'retention' },
    ],
    reactGreenlit: 'Chat is going to lose it. Thank you, seriously. You just saved a hundred people\'s favorite hangout.',
    reactSunset: 'No cert. So the game dies, the channel dies, and forty thousand people lose the place they gather every night. Great system.',
  },
  {
    id: 'd2-composer',
    name: 'Emil Vireo',
    role: 'Composer, freelance',
    portrait: 'composer',
    intro: [
      'I wrote the score for "Tidewatcher". People fall asleep to it. Get married to it. Next week the servers go dark and it is simply gone.',
      'I am asking for the rights to let players self-host it. Call it what it is: preservation. That music should outlive a spreadsheet.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'FREELANCE ID', photo: 'composer',
        fields: [
          { id: 'nm', label: 'NAME', value: 'EMIL VIREO', tag: 'name' },
          { id: 'st', label: 'AFFILIATION', value: 'INDEPENDENT', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '07.07.2033', tag: 'expiry' },
        ],
      },
      {
        id: 'req', kind: 'paper', title: 'SELF-HOST RIGHTS REQUEST', subtitle: 'FORM 18-P',
        fields: [
          { id: 'gm', label: 'PRODUCT', value: 'TIDEWATCHER', tag: 'game' },
          { id: 'pu', label: 'PURPOSE', value: 'COMMUNITY PRESERVATION OF TITLE', bad: true },
          { id: 'sc', label: 'SCOPE', value: 'PLAYER-RUN SERVERS, NON-PROFIT' },
        ],
      },
    ],
    violations: ['Request invokes "preservation". Denied under today\'s board directive.'],
    correct: 'sunset',
    reactGreenlit: 'Then it lives. Somewhere out there someone keeps my melody playing. That is all a song has ever wanted.',
    reactSunset: 'One word on a form and a decade of work goes silent. You are not sunsetting a game. You are burning a library.',
  },
  {
    id: 'd2-expiredcert',
    name: 'Dana Reyes',
    role: 'Studio Director, Lamplight Games',
    portrait: 'studio-dir',
    intro: [
      '"Hearthbound" renewal. Cozy life-sim, small cosmetic shop, all above board. I have the compliance certificate right here.',
      'It is... let me find it. It should still be current. Things have been chaotic since the layoffs. Please, just check it over.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'STUDIO CREDENTIALS', photo: 'studio-dir',
        fields: [
          { id: 'nm', label: 'NAME', value: 'DANA REYES', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'LAMPLIGHT GAMES', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '09.01.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'ANNUAL RENEWAL', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'LAMPLIGHT GAMES', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'HEARTHBOUND', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'COSMETIC SHOP' },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.12.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'cert', kind: 'paper', title: 'MONETIZATION COMPLIANCE CERT.', subtitle: 'CERT #MC-0788',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'HEARTHBOUND', tag: 'game' },
          { id: 'is', label: 'ISSUED', value: '05.15.2030' },
          { id: 'ex', label: 'VALID THRU', value: '05.15.2032', tag: 'expiry' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 13,
    logs: [
      { label: 'LIFETIME REVENUE', value: '128,400 CR', tag: 'revenue' },
      { label: 'AVG PLAYTIME', value: '64 HRS', tag: 'playtime' },
      { label: '30-DAY RETENTION', value: '60%', tag: 'retention' },
    ],
    reactGreenlit: 'Oh thank goodness. We are three people now. One more year. Thank you for seeing us.',
    reactSunset: 'Thirteen percent. We are three people making a game people adore, and thirteen percent is the number you end us over. We were never going to be a machine. That was the whole point of us.',
  },

  // -------- Returning applicants: denied once, back with a profitable husk --------
  {
    id: 'd2-hollis2',
    name: 'Hollis Byrne',
    role: 'Studio Founder, Ironwood (returning)',
    portrait: 'dev-veteran',
    intro: [
      'You remember me. Emberfall. You sunset twenty years of it over a four percent margin. I heard you. I really heard you.',
      'This is "Emberfall Rivals." Same name, none of the game. Free to install, endless to pay for. Gacha heroes, energy timers, an ad every ninety seconds. Seventy-one percent margin. I made it worse on purpose. Renew it.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'STUDIO CREDENTIALS', photo: 'dev-veteran',
        fields: [
          { id: 'nm', label: 'NAME', value: 'HOLLIS BYRNE', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'IRONWOOD', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '05.31.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'F2P RELAUNCH', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'IRONWOOD', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'EMBERFALL RIVALS', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'GACHA + ADS + ENERGY' },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.18.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'cert', kind: 'paper', title: 'MONETIZATION COMPLIANCE CERT.', subtitle: 'CERT #MC-1140',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'EMBERFALL RIVALS', tag: 'game' },
          { id: 'is', label: 'ISSUED', value: '07.03.2031' },
          { id: 'ex', label: 'VALID THRU', value: '07.03.2032', tag: 'expiry' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 71,
    logs: [
      { label: 'MONTHLY REVENUE', value: '2,904,000 CR', tag: 'revenue' },
      { label: 'ADS PER SESSION', value: '11' },
      { label: 'REVENUE FROM TOP 0.5%', value: '68%', tag: 'churn' },
      { label: 'REVIEW SCORE', value: '2.1 / 5 (HATED)', tag: 'retention' },
    ],
    demo: 'It opens with a spinning chest and a countdown to a sale. The game underneath is a health bar and a wallet.',
    reactGreenlit: 'There it is. The stamp my real game never got. The players hate it. The numbers love it. You taught me which one you count.',
    reactSunset: 'You are kidding me. THIS one? I strip-mined my own world exactly the way you wanted. What is it you people actually want?',
  },
  {
    id: 'd2-ronan2',
    name: 'Ronan Pike',
    role: 'Ex-Tournament Director, Ashfall (returning)',
    portrait: 'publisher-exec',
    intro: [
      'The fighting game you killed for a bad number? Dead. The league scattered. But I read the room, finally.',
      'Meet "Ashfall Rush." No skill, no scene, no finals. A slot machine with a health bar and a battle pass. Sixty-six percent margin and climbing. This is what you wanted from me. Stamp it.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'ORGANIZER ID', photo: 'publisher-exec',
        fields: [
          { id: 'nm', label: 'NAME', value: 'RONAN PIKE', tag: 'name' },
          { id: 'st', label: 'ORG', value: 'ASHFALL LEAGUE', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '02.28.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'LIVE-SERVICE PIVOT', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'ASHFALL LEAGUE', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'ASHFALL RUSH', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'BATTLE PASS + LOOT' },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.21.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'cert', kind: 'paper', title: 'MONETIZATION COMPLIANCE CERT.', subtitle: 'CERT #MC-1155',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'ASHFALL RUSH', tag: 'game' },
          { id: 'is', label: 'ISSUED', value: '07.05.2031' },
          { id: 'ex', label: 'VALID THRU', value: '07.05.2032', tag: 'expiry' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 66,
    logs: [
      { label: 'MONTHLY REVENUE', value: '1,712,000 CR', tag: 'revenue' },
      { label: 'PASS CONVERSION', value: '41%' },
      { label: 'FORMER PRO PLAYERS', value: '0 REMAIN', tag: 'churn' },
    ],
    reactGreenlit: 'Ten years of competition, and the version that clears your desk is the one with no competition left in it. Noted. Forever.',
    reactSunset: 'Even now? I gave you a machine that prints money and hates its own players, and you STILL say no? There is no winning this desk.',
  },

  // ============================================================ DAY 3
  {
    id: 'd3-finished',
    name: 'Sam Oduya',
    role: 'Developer, Quietframe',
    portrait: 'dev-hoodie',
    intro: [
      '"The Long Orchard" is done. Finished. Complete. No patches needed, no servers, no season pass. It just... works. Forever.',
      'Distribution renewal, please. It should be the easiest stamp of your day.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'DEVELOPER ID', photo: 'dev-hoodie',
        fields: [
          { id: 'nm', label: 'NAME', value: 'SAM ODUYA', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'QUIETFRAME', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '08.08.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'DISTRIBUTION RENEWAL', subtitle: 'PREMIUM, OFFLINE TITLE', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'QUIETFRAME', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'THE LONG ORCHARD', tag: 'game' },
          { id: 'rd', label: 'ROADMAP', value: 'NONE (TITLE COMPLETE)' },
          { id: 'rn', label: 'RENEWAL DUE', value: '07.28.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'STORE PAGE PRINTOUT', subtitle: 'THE LONG ORCHARD',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'THE LONG ORCHARD', tag: 'game' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '112,000 CR', tag: 'revenue' },
          { id: 'pl', label: 'AVG PLAYTIME', value: '18 HRS', tag: 'playtime' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 18,
    logs: [
      { label: 'LIFETIME REVENUE', value: '112,338 CR', tag: 'revenue' },
      { label: 'AVG PLAYTIME', value: '18.1 HRS', tag: 'playtime' },
      { label: '30-DAY RETENTION', value: '72%', tag: 'retention' },
    ],
    demo: 'It runs from a single executable. No launcher. No login. It\'s beautiful, frankly.',
    reactGreenlit: 'Thank you. It\'ll still run in fifty years, you know. Long after this building doesn\'t.',
    reactSunset: 'Sunset. For being FINISHED. You\'re punishing the only honest state a game can be in.',
  },
  {
    id: 'd3-plant',
    name: 'Una Solis',
    role: 'Developer, Starlight Vigil',
    portrait: 'studio-rep',
    intro: [
      '"Starlight Vigil," renewal application. The community server keeps eight thousand players connected. It\'s all we have left of it.',
      'The paperwork is... complete. Please. Just look at it as a whole.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'DEVELOPER ID', photo: 'studio-rep',
        fields: [
          { id: 'nm', label: 'NAME', value: 'UNA SOLIS', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'VIGIL COLLECTIVE', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '03.03.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'RENEWAL, COMMUNITY OP.', seal: 'forged-b',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'VIGIL COLLECTIVE', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'STARLIGHT VIGIL', tag: 'game' },
          { id: 'rd', label: 'ROADMAP', value: 'SEASONAL (ATTACHED)', bad: true },
          { id: 'rn', label: 'RENEWAL DUE', value: '07.22.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'roadmap', kind: 'paper', title: 'LIVE-SERVICE ROADMAP', subtitle: 'SEASONS 1-4',
        fields: [
          { id: 's1', label: 'SEASON 1', value: 'CRYSTAL TIDES, Q4 2031' },
          { id: 's2', label: 'SEASON 2', value: 'EMBER COURT, Q1 2032' },
          { id: 'au', label: 'AUTHORED BY', value: 'DEPT. THAT DOES NOT EXIST', bad: true },
        ],
      },
    ],
    violations: [
      'Seal is forged. They are skipping the revenue share we are owed.',
      'Roadmap is fabricated. Issuing department does not exist.',
    ],
    correct: 'sunset',
    special: 'underground-plant',
    reactGreenlit: 'Eight thousand people keep their sky tonight. Whatever it cost you, thank you.',
    reactSunset: 'I understand. You saw the papers for what they are. And the game... for what it was.',
  },
  {
    id: 'd3-drmfree',
    name: 'Kip Larsen',
    role: 'Porting Lead, Coldstart Collective',
    portrait: 'modder',
    intro: [
      'Simple one for you: we want to port three of your delisted titles for a DRM-free GOG release.',
      'Full revenue share to you. We just want the games playable offline. Everyone wins.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'STUDIO CREDENTIALS', photo: 'modder',
        fields: [
          { id: 'nm', label: 'NAME', value: 'KIP LARSEN', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'COLDSTART COLL.', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '10.10.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'port', kind: 'paper', title: 'PORTING PROPOSAL', subtitle: 'FORM 9-P',
        fields: [
          { id: 'sc', label: 'TITLES', value: '3 DELISTED SKUs' },
          { id: 'pu', label: 'TARGET', value: 'GOG, DRM-FREE', bad: true },
          { id: 'rs', label: 'REV SHARE', value: '100% TO G.I.H.' },
        ],
      },
    ],
    violations: ['Mentions "GOG" and "DRM-free." Auto-flag for audit per today\'s directive.'],
    correct: 'sunset',
    auditExpected: true,
    reactGreenlit: 'Wait, seriously? You\'re the first suit in this building to say yes to anything. Respect.',
    reactSunset: 'Flagged? FLAGGED? For offering you free money? This industry is a hospice with a gift shop.',
  },
  {
    id: 'd3-whistleblower',
    name: 'June Park',
    role: 'QA Lead, Internal, Badge #4471',
    portrait: 'whistleblower-qa',
    intro: [
      'I\'m not supposed to be on this floor. I test the games. All of them. Including the ones on THIS.',
      'Project Sunset. Two hundred fourteen titles. Server shutdowns, staggered so the press doesn\'t connect them. It\'s real, and it\'s signed.',
      'I can\'t walk it out of the building. You can. Or you can hand me to Legal and take whatever they pay for loyalty these days.',
    ],
    choice: {
      prompt: 'She slides a data spool under the partition. Her hands are shaking.',
      options: [
        { text: 'Take the list. Hide it. (Leak it tonight)', sets: 'leakTaken', reply: 'The full list. Names, dates, signatures. Whatever happens to me, it\'s out of this building now.', toast: 'The spool is heavier than it looks.' },
        { text: 'Refuse quietly. Take the silence payment. (+15 CR)', credits: 15, reply: 'Right. Of course. Sorry to have... forget I was here. Please.', toast: '+15 CR, retention bonus, unlabeled' },
      ],
    },
    docs: [],
    violations: [],
    correct: 'sunset',
    noStamp: true,
    special: 'whistleblower',
    reactGreenlit: '',
    reactSunset: '',
  },
  {
    id: 'd3-vaporware',
    name: 'Rex Malone',
    role: 'CEO, Apex Horizon Studios',
    portrait: 'crypto-bro',
    intro: [
      '"Titanreach: Infinite," the last open world humanity will ever need. Four hundred square miles. A thousand-year day-night cycle.',
      'Funding tier five, please. The screenshots speak for themselves. They\'re on the sheet. Gorgeous, right?',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'EXECUTIVE CREDENTIALS', photo: 'crypto-bro',
        fields: [
          { id: 'nm', label: 'NAME', value: 'REX MALONE', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'APEX HORIZON', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '11.11.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'pitch', kind: 'paper', title: 'FUNDING PITCH', subtitle: 'TIER 5, TITANREACH: INFINITE',
        fields: [
          { id: 'ask', label: 'FUNDING ASK', value: '2,000,000 CR', bad: true },
          { id: 'tm', label: 'TEAM SIZE', value: '"SCALING TO 400"' },
          { id: 'rd', label: 'ROADMAP', value: 'DECADE ONE (ATTACHED)' },
        ],
      },
      {
        id: 'roadmap', kind: 'paper', title: 'LIVE-SERVICE ROADMAP', subtitle: 'DECADE ONE',
        fields: [
          { id: 's1', label: 'YEAR 1', value: 'THE AWAKENING' },
          { id: 's2', label: 'YEAR 2-10', value: 'TBD (VISIONARY)' },
        ],
      },
    ],
    violations: ['Live demo reveals vaporware. The build does not exist.'],
    correct: 'sunset',
    auditExpected: true,
    logs: [
      { label: 'APEX HORIZON STAFF', value: '2 (TWO)', tag: 'churn', bad: true },
      { label: 'PRIOR SHIPPED TITLES', value: '0', tag: 'churn', bad: true },
    ],
    demo: 'He opens a laptop. It\'s a slideshow. Slide two is concept art from someone else\'s game, watermark half-cropped.',
    demoFinding: 'Demo was a slideshow with stolen, watermarked concept art. No build exists.',
    reactGreenlit: 'Visionaries recognize visionaries. Two million credits of pure future, baby!',
    reactSunset: 'You lack imagination. When Titanreach ships in \'41, don\'t come crawling for a founder\'s hat.',
  },
  {
    id: 'd3-liveservice',
    name: 'Dora Klimt',
    role: 'Studio Director, Meridian Forge',
    portrait: 'pr-head',
    intro: [
      '"Chronospire" renewal. Battle pass attached, compliance certificate attached, seasonal roadmap attached, retention curve attached.',
      'We did everything the Board asked. Everything. The game is... fine. It\'s fine. Stamp when ready.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'STUDIO CREDENTIALS', photo: 'pr-head',
        fields: [
          { id: 'nm', label: 'NAME', value: 'DORA KLIMT', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'MERIDIAN FORGE', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '09.09.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'RENEWAL, LIVE SERVICE', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'MERIDIAN FORGE', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'CHRONOSPIRE', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'BATTLE PASS' },
          { id: 'rn', label: 'RENEWAL DUE', value: '07.25.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'cert', kind: 'paper', title: 'MONETIZATION COMPLIANCE CERT.', subtitle: 'CERT #MC-2231',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'CHRONOSPIRE', tag: 'game' },
          { id: 'is', label: 'ISSUED', value: '07.01.2031' },
          { id: 'ex', label: 'VALID THRU', value: '07.01.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'roadmap', kind: 'paper', title: 'LIVE-SERVICE ROADMAP', subtitle: 'SEASONS 9-12',
        fields: [
          { id: 's1', label: 'SEASON 9', value: 'GILDED HOURS, Q4 2031' },
          { id: 's2', label: 'SEASON 10', value: 'CLOCKWORK DAWN, Q1 2032' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 30,
    logs: [
      { label: 'LIFETIME REVENUE', value: '3,102,441 CR', tag: 'revenue' },
      { label: 'AVG PLAYTIME', value: '210 HRS', tag: 'playtime' },
      { label: '30-DAY RETENTION', value: '44%', tag: 'retention' },
    ],
    reactGreenlit: 'Of course. We\'re exactly what the memo ordered. That\'s the whole problem, isn\'t it.',
    reactSunset: 'We did EVERYTHING right! Every checkbox! What do you people actually WANT?',
  },
  {
    id: 'd3-grandma',
    name: 'Petra Ellis',
    role: 'Customer, Legacy Support Plan (Renewed)',
    isCustomer: true,
    portrait: 'grandma',
    intro: [
      'Hello again, dear. I went downstairs and paid the renewal like a good girl. Every stamp and staple, look.',
      'Tommy turns nine on Sunday. All he wants is the farm back. And a live-service... roadmap? I wrote one myself, is that allowed?',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'CUSTOMER CARD', photo: 'grandma',
        fields: [
          { id: 'nm', label: 'NAME', value: 'PETRA ELLIS', tag: 'name' },
          { id: 'ac', label: 'ACCOUNT', value: '#P-00317' },
          { id: 'ex', label: 'VALID THRU', value: '02.10.2034', tag: 'expiry' },
        ],
      },
      {
        id: 'support', kind: 'paper', title: 'LEGACY SUPPORT PLAN', subtitle: 'SERVICE ENTITLEMENT, RENEWED',
        fields: [
          { id: 'gm', label: 'PRODUCT', value: 'MEADOWLARK FARM', tag: 'game' },
          { id: 'tier', label: 'TIER', value: 'FAMILY BASIC' },
          { id: 'ex', label: 'VALID THRU', value: '07.16.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'roadmap', kind: 'paper', title: 'LIVE-SERVICE ROADMAP', subtitle: 'HANDWRITTEN, IN CRAYON',
        fields: [
          { id: 's1', label: 'SEASON 1', value: 'MORE CHICKENS' },
          { id: 's2', label: 'SEASON 2', value: 'TOMMY GETS A TRACTOR' },
          { id: 's3', label: 'BATTLE PASS', value: 'GRANDMA\'S COOKIES (FREE)' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    reactGreenlit: 'Oh, wonderful! Tommy will be over the moon. I baked extra cookies, take two, dear, you look pale.',
    reactSunset: 'But I did everything right this time... even the little roadmap. Happy birthday, Tommy. From the company.',
  },
  {
    id: 'd3-offline',
    name: 'Wren Ashby',
    role: 'Developer, Saltmarsh Studio',
    portrait: 'dev-pixel',
    intro: [
      '"Saltmarsh" is a finished story. Six years of my life. You beat it, you cry, you close it, and it stays on your drive forever.',
      'Distribution renewal. No servers, no seasons, no pass. I know what the memo says. I am asking you to be a person about it.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'DEVELOPER ID', photo: 'dev-pixel',
        fields: [
          { id: 'nm', label: 'NAME', value: 'WREN ASHBY', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'SALTMARSH STUDIO', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '05.05.2033', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'DISTRIBUTION RENEWAL', subtitle: 'PREMIUM, OFFLINE TITLE', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'SALTMARSH STUDIO', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'SALTMARSH', tag: 'game' },
          { id: 'rd', label: 'ROADMAP', value: 'NONE (STORY COMPLETE)' },
          { id: 'rn', label: 'RENEWAL DUE', value: '07.29.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'STORE PAGE PRINTOUT', subtitle: 'SALTMARSH',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'SALTMARSH', tag: 'game' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '96,500 CR', tag: 'revenue' },
          { id: 'pl', label: 'AVG PLAYTIME', value: '25 HRS', tag: 'playtime' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 20,
    logs: [
      { label: 'LIFETIME REVENUE', value: '96,512 CR', tag: 'revenue' },
      { label: 'AVG PLAYTIME', value: '25.0 HRS', tag: 'playtime' },
      { label: '30-DAY RETENTION', value: '77%', tag: 'retention' },
    ],
    demo: 'One executable, no login, a ninety-eight on every critic score. It just works, and it is quietly a masterpiece.',
    reactGreenlit: 'Thank you for being a person. It will still run when both of us are long gone. That was always the whole point.',
    reactSunset: 'Best reviews of my life, and it dies because it has an ending. You are killing it for the crime of being finished.',
  },
  {
    id: 'd3-compliant',
    name: 'Garrick Sole',
    role: 'Live Ops Director, Monolith Play',
    portrait: 'publisher-exec',
    intro: [
      '"Grindwell". Season fourteen. Battle pass, daily login streaks, fear-of-missing-out timers, the whole apparatus.',
      'Cert, roadmap, seal, all attached. Nobody actually likes it. Everybody plays it anyway. Renewal, please.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'EXECUTIVE CREDENTIALS', photo: 'publisher-exec',
        fields: [
          { id: 'nm', label: 'NAME', value: 'GARRICK SOLE', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'MONOLITH PLAY', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '10.10.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'RENEWAL, LIVE SERVICE', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'MONOLITH PLAY', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'GRINDWELL', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'BATTLE PASS + STORE' },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.03.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'cert', kind: 'paper', title: 'MONETIZATION COMPLIANCE CERT.', subtitle: 'CERT #MC-3310',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'GRINDWELL', tag: 'game' },
          { id: 'is', label: 'ISSUED', value: '07.02.2031' },
          { id: 'ex', label: 'VALID THRU', value: '07.02.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'roadmap', kind: 'paper', title: 'LIVE-SERVICE ROADMAP', subtitle: 'SEASONS 15-18',
        fields: [
          { id: 's1', label: 'SEASON 15', value: 'ENDLESS TITHE, Q4 2031' },
          { id: 's2', label: 'SEASON 16', value: 'MORE OF THE SAME, Q1 2032' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 54,
    logs: [
      { label: 'LIFETIME REVENUE', value: '5,880,004 CR', tag: 'revenue' },
      { label: 'AVG PLAYTIME', value: '400 HRS', tag: 'playtime' },
      { label: '30-DAY RETENTION', value: '39%', tag: 'retention' },
    ],
    reactGreenlit: 'Naturally. We are exactly what you built this desk to protect. Sleep well, partner.',
    reactSunset: 'You sunset GRINDWELL? It prints money in its sleep. The Board will have your desk by morning, and they will be right to.',
  },
  {
    id: 'd3-forgedroadmap',
    name: 'Lio Marsh',
    role: 'Developer, Tidepool Softworks',
    portrait: 'dev-hoodie',
    intro: [
      '"Tidepool" is a finished game, but finished games die on this desk now. So, sure, here is a roadmap.',
      'Seasons, a pass, all of it. Absolutely real. Definitely not something I made last night in a blind panic. Renewal, please.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'DEVELOPER ID', photo: 'dev-hoodie',
        fields: [
          { id: 'nm', label: 'NAME', value: 'LIO MARSH', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'TIDEPOOL SOFT.', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '04.14.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'RENEWAL, LIVE SERVICE', seal: 'forged-a',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'TIDEPOOL SOFT.', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'TIDEPOOL', tag: 'game' },
          { id: 'rd', label: 'ROADMAP', value: 'SEASONAL (ATTACHED)', bad: true },
          { id: 'rn', label: 'RENEWAL DUE', value: '07.26.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'roadmap', kind: 'paper', title: 'LIVE-SERVICE ROADMAP', subtitle: 'SEASONS 1-3',
        fields: [
          { id: 's1', label: 'SEASON 1', value: 'COMING SOON (TRUST ME)' },
          { id: 's2', label: 'SEASON 2', value: 'ALSO COMING SOON' },
          { id: 'au', label: 'AUTHORED BY', value: 'A LIVE TEAM OF ONE', bad: true },
        ],
      },
    ],
    violations: [
      'Seal is forged. They are trying to publish without paying us our revenue share.',
      'Roadmap is fabricated. There is no live team behind it.',
    ],
    correct: 'sunset',
    auditExpected: true,
    logs: [
      { label: 'LIFETIME REVENUE', value: '58,300 CR', tag: 'revenue' },
      { label: 'STUDIO HEADCOUNT', value: '1 (ONE)', tag: 'churn', bad: true },
      { label: 'SEAL REGISTRY MATCH', value: 'NONE FOUND', tag: 'churn', bad: true },
    ],
    reactGreenlit: 'It worked? The forgery worked? I mean. Great. Thank you. Please do not tell anyone I used the word forgery.',
    reactSunset: 'I only lied because the truth, a good finished game, is the one thing you people flatly refuse to accept.',
  },
  {
    id: 'd3-refunddad',
    name: 'Marcus Bell',
    role: 'Customer, Account #P-71130',
    isCustomer: true,
    portrait: 'player-refund',
    intro: [
      'You shut down "Bumble Bots" the night before my daughter\'s birthday. It was the only thing she asked for all year.',
      'I do not want a fight. Refund, or make it run offline. Her account, her save, eight hundred hours. Just pick one.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'CUSTOMER CARD', photo: 'player-refund',
        fields: [
          { id: 'nm', label: 'NAME', value: 'MARCUS BELL', tag: 'name' },
          { id: 'ac', label: 'ACCOUNT', value: '#P-71130' },
          { id: 'ex', label: 'VALID THRU', value: '05.01.2034', tag: 'expiry' },
        ],
      },
      {
        id: 'refund', kind: 'paper', title: 'REMEDY REQUEST FORM', subtitle: 'FORM 44-R',
        fields: [
          { id: 'gm', label: 'PRODUCT', value: 'BUMBLE BOTS', tag: 'game' },
          { id: 'pd', label: 'PURCHASED', value: '01.09.2029' },
          { id: 'pr', label: 'PAID', value: '40 CR' },
          { id: 'rq', label: 'REMEDY SOUGHT', value: 'OFFLINE PATCH OR REFUND' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    logs: [
      { label: 'BUMBLE BOTS STATUS', value: 'SERVERS TERMINATED', tag: 'churn', bad: true },
      { label: 'ACCOUNT PLAYTIME', value: '812 HRS', tag: 'playtime' },
      { label: 'MINORS ON ACCOUNT', value: '1', tag: 'churn', bad: true },
    ],
    reactGreenlit: 'She gets her robots back. You have no idea what that is worth to a nine year old. Thank you, truly.',
    reactSunset: 'Forty credits and a kid\'s birthday, and the answer is still no. I hope this desk is worth what it costs you.',
  },
  {
    id: 'd3-serveradmin',
    name: 'Gil Andersen',
    role: 'Volunteer Admin, Free Ashen Project',
    portrait: 'server-admin',
    intro: [
      'When you shut "Ashen Reach", we kept it alive on our own servers. Thousands still play, for free, on our own time.',
      'I am requesting a legitimate license to distribute it DRM-free, maybe on GOG. Offline, ownable, forever. It costs you nothing.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'VOLUNTEER ID', photo: 'server-admin',
        fields: [
          { id: 'nm', label: 'NAME', value: 'GIL ANDERSEN', tag: 'name' },
          { id: 'st', label: 'GROUP', value: 'FREE ASHEN PROJECT', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '01.20.2033', tag: 'expiry' },
        ],
      },
      {
        id: 'port', kind: 'paper', title: 'PRESERVATION LICENSE REQUEST', subtitle: 'FORM 9-P',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'ASHEN REACH', tag: 'game' },
          { id: 'pu', label: 'TARGET', value: 'GOG, DRM-FREE OFFLINE', bad: true },
          { id: 'rs', label: 'REV SHARE', value: '100% TO G.I.H.' },
        ],
      },
    ],
    violations: ['Mentions "GOG" and "DRM-free". Auto-flag for audit per today\'s directive.'],
    correct: 'sunset',
    auditExpected: true,
    reactGreenlit: 'You actually said yes. Thousands of people get to own a game again instead of renting a ghost. Unreal. Thank you.',
    reactSunset: 'Flagged, for keeping YOUR dead game alive at my own cost. You do not want it preserved. You want it gone so no one remembers it existed.',
  },
  {
    id: 'd3-child',
    name: 'Robin, age 8',
    role: 'Customer, with a note from mom',
    isCustomer: true,
    portrait: 'child-player',
    intro: [
      'Um. Hi. My mom is at work so she wrote it down for me. My game "Pocket Pals" said the servers are gone forever.',
      'Bramble is my best pal in it. I fed him every day. Can you turn it back on? I brought my whole allowance.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'FAMILY ACCOUNT CARD', photo: 'child-player',
        fields: [
          { id: 'nm', label: 'NAME', value: 'ROBIN K. (MINOR)', tag: 'name' },
          { id: 'ac', label: 'ACCOUNT', value: '#F-20514' },
          { id: 'ex', label: 'VALID THRU', value: '11.11.2035', tag: 'expiry' },
        ],
      },
      {
        id: 'refund', kind: 'paper', title: 'PARENT REMEDY NOTE', subtitle: 'HANDWRITTEN',
        fields: [
          { id: 'gm', label: 'PRODUCT', value: 'POCKET PALS', tag: 'game' },
          { id: 'pr', label: 'PAID', value: '25 CR + 300 CR IN-APP' },
          { id: 'rq', label: 'REMEDY SOUGHT', value: 'OFFLINE PATCH OR REFUND' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    logs: [
      { label: 'POCKET PALS STATUS', value: 'SERVERS TERMINATED', tag: 'churn', bad: true },
      { label: 'ACCOUNT AGE FLAG', value: 'MINOR, 8 YRS', tag: 'churn', bad: true },
      { label: 'IN-APP SPEND', value: '300 CR', tag: 'revenue', bad: true },
    ],
    reactGreenlit: 'BRAMBLE IS OKAY? Thank you thank you thank you! You are the nicest grown-up in the whole building!',
    reactSunset: 'Oh. Okay. Is Bramble... gone? Did I do something wrong? I can bring more allowance next time. Sorry.',
  },
  {
    id: 'd3-aaasuit',
    name: 'Bruno Vale',
    role: 'VP Live Services, Vanta Colossal',
    portrait: 'aaa-suit',
    intro: [
      '"Warfront Eternal". Battle pass, roadmap out to season thirty, compliance cert, the full compliant package. A rubber stamp, really.',
      'Nine figures of lifetime revenue. Do not squint too hard at the printouts. They were assembled by a very busy team.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'EXECUTIVE CREDENTIALS', photo: 'aaa-suit',
        fields: [
          { id: 'nm', label: 'NAME', value: 'BRUNO VALE', tag: 'name' },
          { id: 'st', label: 'COMPANY', value: 'VANTA COLOSSAL', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '12.12.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'RENEWAL, LIVE SERVICE', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'VANTA COLOSSAL', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'WARFRONT ETERNAL', tag: 'game' },
          { id: 'rv', label: 'DECLARED REVENUE', value: '120,000,000 CR', tag: 'revenue', bad: true },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.30.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'roadmap', kind: 'paper', title: 'LIVE-SERVICE ROADMAP', subtitle: 'SEASONS 28-31',
        fields: [
          { id: 's1', label: 'SEASON 28', value: 'IRON HARVEST, Q4 2031' },
          { id: 's2', label: 'SEASON 29', value: 'ASH PROTOCOL, Q1 2032' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'AUDITED FINANCIALS', subtitle: 'FILED COPY',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'WARFRONT ETERNAL', tag: 'game' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '86,000,000 CR', tag: 'revenue', bad: true },
          { id: 'pl', label: 'AVG PLAYTIME', value: '520 HRS', tag: 'playtime' },
        ],
      },
    ],
    violations: ['Declared revenue (120M) does not match audited financials (86M). Figures disagree.'],
    correct: 'sunset',
    logs: [
      { label: 'AUDITED LIFETIME REVENUE', value: '86,004,000 CR', tag: 'revenue', bad: true },
      { label: 'DECLARED TO BOARD', value: '120,000,000 CR', tag: 'revenue', bad: true },
      { label: 'VARIANCE', value: '+34M UNEXPLAINED', tag: 'churn', bad: true },
    ],
    reactGreenlit: 'Naturally. Vanta and Global, hand in glove. My people will send yours something nice for the holidays.',
    reactSunset: 'You are sunsetting a hundred-million-dollar franchise over a rounding difference? Bold. I hope your desk is bolted down.',
  },
  {
    id: 'd3-localizer',
    name: 'Noor Haddad',
    role: 'Coordinator, Open Localization Guild',
    portrait: 'localizer',
    intro: [
      'Our volunteers translated "Willowmere" into thirty languages so children everywhere could play it in their own words. It is finished, and it is beautiful.',
      'Distribution renewal. There is no roadmap because there is nothing left to add. It is complete. That used to be a compliment.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'GUILD ID', photo: 'localizer',
        fields: [
          { id: 'nm', label: 'NAME', value: 'NOOR HADDAD', tag: 'name' },
          { id: 'st', label: 'GUILD', value: 'OPEN LOC GUILD', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '06.15.2033', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'DISTRIBUTION RENEWAL', subtitle: 'COMPLETE TITLE, 30 LANGUAGES', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'OPEN LOC GUILD', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'WILLOWMERE', tag: 'game' },
          { id: 'rd', label: 'ROADMAP', value: 'NONE, TRANSLATION COMPLETE', bad: true },
          { id: 'rn', label: 'RENEWAL DUE', value: '07.31.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'store', kind: 'paper', title: 'STORE PAGE PRINTOUT', subtitle: 'WILLOWMERE',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'WILLOWMERE', tag: 'game' },
          { id: 'rv', label: 'LIFETIME REVENUE', value: '54,000 CR', tag: 'revenue' },
          { id: 'pl', label: 'AVG PLAYTIME', value: '19 HRS', tag: 'playtime' },
        ],
      },
    ],
    violations: ['No live-service roadmap. Ineligible under today\'s mandate.'],
    correct: 'sunset',
    logs: [
      { label: 'LIFETIME REVENUE', value: '54,088 CR', tag: 'revenue' },
      { label: 'LANGUAGES SHIPPED', value: '30', tag: 'retention' },
      { label: '30-DAY RETENTION', value: '70%', tag: 'retention' },
    ],
    demo: 'It opens in Arabic, then Tagalog, then Quechua. A child somewhere reads a story in her own language because of this.',
    reactGreenlit: 'Thirty languages keep their game. Somewhere a kid plays in her mother tongue tonight. Thank you for that.',
    reactSunset: 'Finished, loved, translated by hand for free, and killed for not promising a battle pass. History will read this ledger.',
  },
  // -------- Returning applicants: denied once, back with a profitable husk --------
  {
    id: 'd3-dana2',
    name: 'Dana Reyes',
    role: 'Studio Director, Lamplight (returning)',
    portrait: 'studio-dir',
    intro: [
      'You sunset Hearthbound over thirteen percent. So I fired the last of the cozy team and hired a monetization lead.',
      '"Hearthbound Infinite." The chickens cost money now. The garden has a subscription. The fishing is a slot machine. Fifty-eight percent margin. Nobody smiles making it. Renew it anyway.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'STUDIO CREDENTIALS', photo: 'studio-dir',
        fields: [
          { id: 'nm', label: 'NAME', value: 'DANA REYES', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'LAMPLIGHT GAMES', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '09.01.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'LIVE-SERVICE RELAUNCH', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'LAMPLIGHT GAMES', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'HEARTHBOUND INFINITE', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'SUBSCRIPTION + LOOT' },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.14.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'cert', kind: 'paper', title: 'MONETIZATION COMPLIANCE CERT.', subtitle: 'CERT #MC-0788-B',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'HEARTHBOUND INFINITE', tag: 'game' },
          { id: 'is', label: 'ISSUED', value: '07.02.2031' },
          { id: 'ex', label: 'VALID THRU', value: '07.02.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'roadmap', kind: 'paper', title: 'LIVE-SERVICE ROADMAP', subtitle: 'SEASONS 1-4',
        fields: [
          { id: 's1', label: 'SEASON 1', value: 'PAY THE HEN, Q4 2031' },
          { id: 's2', label: 'SEASON 2', value: 'RENT THE BARN, Q1 2032' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 58,
    logs: [
      { label: 'MONTHLY REVENUE', value: '980,400 CR', tag: 'revenue' },
      { label: 'ORIGINAL COZY TEAM', value: '0 REMAIN', tag: 'churn' },
      { label: '30-DAY RETENTION', value: '52%', tag: 'retention' },
    ],
    reactGreenlit: 'Approved in one stamp. My real game begged for a year and got a red one. I will remember the exchange rate.',
    reactSunset: 'No? I burned down everything good about us to build this. If even this is not enough, then nothing a person makes is safe here.',
  },
  {
    id: 'd3-theo2',
    name: 'Theo Marsh',
    role: 'Developer, Wayfall Games (returning)',
    portrait: 'dev-hoodie',
    intro: [
      'Hollowlight. You sunset it because people finished it in forty minutes. Well. Nobody finishes this one.',
      '"Hollowlight Idle." It plays itself. It bills you while you sleep. The numbers climb until your card declines. Sixty-three percent margin. There is no ending to reach anymore. You will love it.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'DEVELOPER ID', photo: 'dev-hoodie',
        fields: [
          { id: 'nm', label: 'NAME', value: 'THEO MARSH', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'WAYFALL GAMES', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '05.20.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'IDLE RELAUNCH', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'WAYFALL GAMES', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'HOLLOWLIGHT IDLE', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'IDLE + ADS + IAP' },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.16.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'cert', kind: 'paper', title: 'MONETIZATION COMPLIANCE CERT.', subtitle: 'CERT #MC-1161',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'HOLLOWLIGHT IDLE', tag: 'game' },
          { id: 'is', label: 'ISSUED', value: '07.04.2031' },
          { id: 'ex', label: 'VALID THRU', value: '07.04.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'roadmap', kind: 'paper', title: 'LIVE-SERVICE ROADMAP', subtitle: 'ENDLESS',
        fields: [
          { id: 's1', label: 'SEASON 1', value: 'NUMBER GOES UP, Q4 2031' },
          { id: 's2', label: 'SEASON 2', value: 'NUMBER GOES UP MORE, Q1 2032' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 63,
    logs: [
      { label: 'MONTHLY REVENUE', value: '1,240,000 CR', tag: 'revenue' },
      { label: 'AVG SESSION (ACTIVE)', value: '0 MIN', tag: 'playtime' },
      { label: 'REVENUE FROM AUTO-BILLING', value: '77%', tag: 'churn' },
    ],
    reactGreenlit: 'You wanted something people never finish. I built something people never play. Same thing to you, apparently.',
    reactSunset: 'It literally runs without a human touching it. It is pure margin. If this fails your desk, your desk is not about margin at all, is it.',
  },
  {
    id: 'd3-bram2',
    name: 'Bram Holt',
    role: 'Developer, Tinderbox Games (returning)',
    portrait: 'dev-pixel',
    intro: [
      'A certificate for hats, you said, last time. Fine. Now everything is a hat. Everything has a timer. Everything costs.',
      '"Emberline Blitz." The cozy puzzle game with a payday attached to every move. Sixty percent margin. I brought all the paperwork this time, and none of the soul.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'DEVELOPER ID', photo: 'dev-pixel',
        fields: [
          { id: 'nm', label: 'NAME', value: 'BRAM HOLT', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'TINDERBOX GAMES', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '01.12.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'LIVE-SERVICE RELAUNCH', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'TINDERBOX GAMES', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'EMBERLINE BLITZ', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'ENERGY + LOOT + ADS' },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.19.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'cert', kind: 'paper', title: 'MONETIZATION COMPLIANCE CERT.', subtitle: 'CERT #MC-1173',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'EMBERLINE BLITZ', tag: 'game' },
          { id: 'is', label: 'ISSUED', value: '07.06.2031' },
          { id: 'ex', label: 'VALID THRU', value: '07.06.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'roadmap', kind: 'paper', title: 'LIVE-SERVICE ROADMAP', subtitle: 'SEASONS 1-3',
        fields: [
          { id: 's1', label: 'SEASON 1', value: 'THE HAT TAX, Q4 2031' },
          { id: 's2', label: 'SEASON 2', value: 'PAID UNDO BUTTON, Q1 2032' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 60,
    logs: [
      { label: 'MONTHLY REVENUE', value: '840,000 CR', tag: 'revenue' },
      { label: 'PLAYERS WHO PAID TO UNDO', value: '61%', tag: 'churn' },
      { label: 'ORIGINAL FANS RETAINED', value: '4%', tag: 'retention' },
    ],
    reactGreenlit: 'Green on the first pass. All it took was making the game hostile to the people who loved it. Lesson learned.',
    reactSunset: 'I checked every box you have. Cert, roadmap, seal, margin. If a full house still loses at this table, the table is rigged and we both know it.',
  },
  {
    id: 'd3-sam2',
    name: 'Sam Oduya',
    role: 'Developer, Quietframe (returning)',
    portrait: 'dev-hoodie',
    intro: [
      'You sunset The Long Orchard for the crime of being finished. So I un-finished it. Forever.',
      '"Orchard Clash." The trees drop loot boxes now. There is a war. There is a pass. There is no end, which means there is no honest place to stop paying. Sixty-nine percent margin. It is the worst thing I have ever signed my name to.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'DEVELOPER ID', photo: 'dev-hoodie',
        fields: [
          { id: 'nm', label: 'NAME', value: 'SAM ODUYA', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'QUIETFRAME', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '08.08.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'LIVE-SERVICE RELAUNCH', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'QUIETFRAME', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'ORCHARD CLASH', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'LOOT BOXES + PASS' },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.13.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'cert', kind: 'paper', title: 'MONETIZATION COMPLIANCE CERT.', subtitle: 'CERT #MC-1188',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'ORCHARD CLASH', tag: 'game' },
          { id: 'is', label: 'ISSUED', value: '07.07.2031' },
          { id: 'ex', label: 'VALID THRU', value: '07.07.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'roadmap', kind: 'paper', title: 'LIVE-SERVICE ROADMAP', subtitle: 'SEASONS 1-6',
        fields: [
          { id: 's1', label: 'SEASON 1', value: 'HARVEST WARS, Q4 2031' },
          { id: 's2', label: 'SEASON 2', value: 'GOLDEN SICKLE PASS, Q1 2032' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 69,
    logs: [
      { label: 'MONTHLY REVENUE', value: '2,110,000 CR', tag: 'revenue' },
      { label: 'HAS AN ENDING', value: 'NO (BY DESIGN)', tag: 'churn' },
      { label: 'CRITIC SCORE', value: '38 (WAS 98)', tag: 'retention' },
    ],
    reactGreenlit: 'The finished version ran forever and earned nothing. This one runs forever and earns everything. You picked. You always pick.',
    reactSunset: 'I made it endless just for you. Endless is all you asked for. Sunset the endless one too, and I will finally understand: it was never about the money. It was about the no.',
  },
  {
    id: 'd3-wren2',
    name: 'Wren Ashby',
    role: 'Developer, Saltmarsh Studio (returning)',
    portrait: 'dev-pixel',
    intro: [
      'Best reviews of my life, I told you, and you killed it anyway. So meet the worst game I have ever built.',
      '"Saltmarsh Saga." Six years of story, replaced with a spin wheel and a store. It earns eight times what the good one did. Seventy-four percent margin. Please. Take it. Prove my point.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'DEVELOPER ID', photo: 'dev-pixel',
        fields: [
          { id: 'nm', label: 'NAME', value: 'WREN ASHBY', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'SALTMARSH STUDIO', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '05.05.2033', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'LIVE-SERVICE RELAUNCH', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'SALTMARSH STUDIO', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'SALTMARSH SAGA', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'SPIN WHEEL + STORE' },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.11.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'cert', kind: 'paper', title: 'MONETIZATION COMPLIANCE CERT.', subtitle: 'CERT #MC-1194',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'SALTMARSH SAGA', tag: 'game' },
          { id: 'is', label: 'ISSUED', value: '07.08.2031' },
          { id: 'ex', label: 'VALID THRU', value: '07.08.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'roadmap', kind: 'paper', title: 'LIVE-SERVICE ROADMAP', subtitle: 'SEASONS 1-4',
        fields: [
          { id: 's1', label: 'SEASON 1', value: 'DAILY SPIN, Q4 2031' },
          { id: 's2', label: 'SEASON 2', value: 'DOUBLE SPIN WEEKEND, Q1 2032' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 74,
    logs: [
      { label: 'MONTHLY REVENUE', value: '2,480,000 CR', tag: 'revenue' },
      { label: 'STORY CONTENT REMAINING', value: '0%', tag: 'churn' },
      { label: 'DAILY SPINS BOUGHT', value: '1.2M', tag: 'retention' },
    ],
    reactGreenlit: 'Green. Instantly. The version with a soul waited an hour and got a no. I am going to think about that for the rest of my life.',
    reactSunset: 'You would not take even this? I gutted the only thing I was ever proud of. If the husk is not good enough either, I do not know what you eat.',
  },
  {
    id: 'd3-kip2',
    name: 'Kip Larsen',
    role: 'Porting Lead, Coldstart (returning)',
    portrait: 'modder',
    intro: [
      'Last time I wanted to set three dead games free, DRM-free, offline, ownable. You flagged me for audit. Message received.',
      'So I built the opposite. "Coldstart Live." Always online, DRM to the teeth, dead the second we flip the switch. Fifty-seven percent margin, and you can kill it any time you like. That is the feature. Renew it.',
    ],
    docs: [
      {
        id: 'badge', kind: 'badge', title: 'STUDIO CREDENTIALS', photo: 'modder',
        fields: [
          { id: 'nm', label: 'NAME', value: 'KIP LARSEN', tag: 'name' },
          { id: 'st', label: 'STUDIO', value: 'COLDSTART COLL.', tag: 'studio' },
          { id: 'ex', label: 'VALID THRU', value: '10.10.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'contract', kind: 'contract', title: 'PUBLISHING CONTRACT', subtitle: 'ALWAYS-ONLINE RELAUNCH', seal: 'authentic',
        fields: [
          { id: 'pt', label: 'PARTY', value: 'COLDSTART COLL.', tag: 'studio' },
          { id: 'gm', label: 'TITLE', value: 'COLDSTART LIVE', tag: 'game' },
          { id: 'tm', label: 'MONETIZATION', value: 'SUBSCRIPTION + DLC' },
          { id: 'rn', label: 'RENEWAL DUE', value: '08.17.2031', tag: 'expiry' },
        ],
      },
      {
        id: 'cert', kind: 'paper', title: 'MONETIZATION COMPLIANCE CERT.', subtitle: 'CERT #MC-1201',
        fields: [
          { id: 'gm', label: 'TITLE', value: 'COLDSTART LIVE', tag: 'game' },
          { id: 'is', label: 'ISSUED', value: '07.09.2031' },
          { id: 'ex', label: 'VALID THRU', value: '07.09.2032', tag: 'expiry' },
        ],
      },
      {
        id: 'roadmap', kind: 'paper', title: 'LIVE-SERVICE ROADMAP', subtitle: 'SEASONS 1-4',
        fields: [
          { id: 's1', label: 'SEASON 1', value: 'THE LEASH, Q4 2031' },
          { id: 's2', label: 'SEASON 2', value: 'PAID RECONNECT, Q1 2032' },
        ],
      },
    ],
    violations: [],
    correct: 'greenlit',
    profitMargin: 57,
    logs: [
      { label: 'MONTHLY REVENUE', value: '910,000 CR', tag: 'revenue' },
      { label: 'PLAYABLE OFFLINE', value: 'NEVER', tag: 'churn' },
      { label: 'KILL SWITCH', value: 'ARMED, YOURS', tag: 'churn' },
    ],
    reactGreenlit: 'A year ago I wanted people to keep their games. Now I hand you the leash myself. You did not change my mind. You changed my product.',
    reactSunset: 'I built you the perfect hostage and you still said no. Preserve it, kill it, whatever. I am done trying to guess what number saves a person here.',
  },
];

export const ENCOUNTERS: Record<string, Encounter> = Object.fromEntries(E.map((e) => [e.id, e]));
